import React, { useEffect, useState } from "react";
import Header from "../../sharedScreens/Header";
import RoomIcon from "@mui/icons-material/Room";
import Badge from "../../components/basicComponent/Badge";
import RoomPriceDetailCard from "../../components/composite/hotelRoomDetailcard/RoomPriceDetailCard";
import { useLocation, useNavigate } from "react-router-dom";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import { PaymentModeCard } from "../../components/composite/PaymentModeCard";
import { HotelServices } from "../../services/hotelSearch/HotelSearchService";
import { UtilService } from "../../services/shared/UtilService";
import { PGRes } from "@/constants/types";
import { generateRandomInteger, generateUUID } from "../../constants/helper";
import { useGlobalState } from "../../services/context/AuthContext";
import { CoorporateType } from "../../constants/enum";
import Swal from "sweetalert2";
import { useAlert } from "../../services/customHooks/useAlert";
import { Checkbox } from "@mui/material";
import { msgTypes } from "../../constants/msgTypes";

const HotelBookingDetail = () => {
  const { showAlert } = useAlert();
  const [isCheckBoxChecked, setIsCheckBoxChecked] = useState<boolean>(false);
  const location = useLocation();
  const navigate = useNavigate();
  const payload = location.state?.payload;
  const hotel = payload || {}; // hotel and room data
  const guestData = payload?.guestData || [];
  const contact = payload?.contact || {};
  const gst = payload?.gst || {};
  const checkIn = new Date(hotel?.CheckInDate);
  const checkOut = new Date(hotel?.CheckOutDate);
  const timeDiff = checkOut.getTime() - checkIn.getTime();
  const nights = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) || 1;
  const { userInfo, setUserInfo } = useGlobalState();

  const createBooking = async () => {
    try {
      const numberOfRooms = hotel?.Guests?.Count || 1;
      const guestsPerRoom = Math.ceil(guestData.length / numberOfRooms);

      const distributedRooms = Array.from(
        { length: numberOfRooms },
        (_, index) => {
          const start = index * guestsPerRoom;
          const end = start + guestsPerRoom;

          const guestsForThisRoom = guestData.slice(start, end);

          return {
            AdultDetails: guestsForThisRoom.map((guest: any) => ({
              Age: guest?.Age || 30,
              firstName: guest?.firstName || "Guest",
              lastName: guest?.lastName || "User",
              PaxType: guest?.PaxType || "0",
              Prefix: guest?.title || "Mr",
            })),
            ChildDetails: [], // Add if needed
            rateCode: hotel?.rateCode || hotel?.RateKey || "",
            rateKey: hotel?.RateKey || "",
            roomType: hotel?.RoomType || "",
            roomTypeCode: hotel?.RoomTypeCode || "",
            smokingPreference: null,
          };
        }
      );

      const bookingPayload = {
        AddressDetail: {
          address: hotel?.HotelAddress || "",
          city: hotel?.hotelCity || "Delhi",
          countryCode: "IN",
        },
    
        BookingID: null,
        CancellationPolicy: hotel?.CancellationPolicy || "",
        chargeableRate: hotel?.TotalPrice || hotel?.total || 0,
        checkInDate: hotel?.CheckInDate,
        checkOutDate: hotel?.CheckOutDate,
        checkInTime: hotel?.CheckInTime || "12:00 PM",
        checkOutTime: hotel?.CheckOutTime || "11:00 AM",
        City: hotel?.hotelCity || null,
        Country: hotel?.hotelCountry || null,
        CurrencyCode: hotel?.currencyCode || "INR",
        EMTCommonID: "EMTHOTEL-4521578",
        EngineID: hotel?.Engine || "22",
        HotelChain: null,
        hotelID: hotel?.HotelID || "",
        HotelReservationInfo: {
          BankCountryCode: null,
          BankName: null,
          Email: contact?.email || "",
          ExpirationYear: null,
          Title: guestData?.[0]?.title || "Mr",
          cardNumber: null,
          cardType: null,
          creditCardIdentifier: null,
          expirationMonth: null,
          firstName: guestData?.[0]?.firstName || "Guest",
          lastName: guestData?.[0]?.lastName || "User",
        },
        totalAmount: hotel?.total || 0,
        taxRate: hotel?.taxRate || 0,
        price: hotel?.Price || 0,
        disc: hotel?.disc || 0,
        Meal: hotel?.Meal || "Room_Only",
        MealType: hotel?.MealType || "Room_Only",
        Name: hotel?.HotelName || "Unknown Hotel",
        Nationality: "IN",
        rateCode: hotel?.rateCode || hotel?.RateKey || "",
        rateKey: hotel?.RateKey || "",
        roomRateDescription: hotel?.roomRateDescription || "",
        Rooms: {
          Count: numberOfRooms,
          Room: distributedRooms,
        },
        roomType: hotel?.RoomType || "",
        roomTypeCode: hotel?.RoomTypeCode || "",
        Tax: "0",
        Transactionid: 91209460,
        TransactionIdentifier: "",
        TransactionRefNo: "EMT81123_TEST",
        UniqueID: null,
      };

      const response = await HotelServices.getHotelBooking(bookingPayload);

      const {  ...payloadWithoutAuth } = bookingPayload;

      const res = {
        ...response?.data,
        booking_req: payloadWithoutAuth,
        booking_res: response?.data,
      };

      return res;
    } catch (error) {
      console.error("❌ Booking failed:", error);
      alert("Booking failed. Please try again.");
    }
  };
  const fetchBalance = async () => {
    try {
      const response = await UtilService.fetchBalance();
      if (response?.statusMsg === msgTypes?.SUCCESS?.msg) {
        // Assuming the response contains the balance data
        setUserInfo({
          ...userInfo,
          postpaidBalance: response.data?.postpaid || 0,
          prepaidBalance: response.data?.prepaid || 0,
        });
      } else {
        console.error("Failed to fetch balance data");
      }
    } catch (error) {}
  };

  const saveBookingDetail = async (
    id: string,
    bookingType: string,
    paymentType: string,
    pgRes?: PGRes | null,
    bookingRes?: any | null
  ) => {
    try {
      const hotelPaymentPayload = {
        booking_txn_id: id, // you can generate new UUID
        booking_type: bookingType,
        payment_type: paymentType,
        amount: bookingRes?.booking_req?.chargeableRate || 0,
        ag_id: pgRes?.ag_id,
        ag_ref: pgRes?.ag_ref,
        country: pgRes?.country,
        currency: pgRes?.currency,
        me_id: pgRes?.me_id,
        order_number: pgRes?.order_number,
        status: pgRes?.status,
        transaction_date: pgRes?.transaction_date,
        transaction_time: pgRes?.transaction_time,
        booking_req: {
          ...bookingRes?.booking_req,
          Transactionid: 11411206 + generateRandomInteger(),
        },
        booking_res: bookingRes?.booking_res,
      };

      const response = await UtilService.captureTransaction(
        hotelPaymentPayload
      );

      if (!!response) {
        Swal.fire({
          icon: "success",
          title: "Booking Confirmed!",
          text: `Your Flight has been successfully booked. Check your email for ticket details.`,
          confirmButtonText: "OK",
          confirmButtonColor: "#3085d6",
        }).then(() => {
          navigate("/managehotelbooking"); // ✅ Replace with your actual route
        });

        fetchBalance();
        return true;
      } else {
        showAlert({
          title: "Error",
          text: "Something went wrong. Please try again.",
          icon: "error",
        });
        return false;
      }
    } catch (error) {
      console.error("❌ Hotel Payment API failed:", error);
      alert("Hotel Payment API Failed!");
    }
  };

  const TermsAndCondition = () => (
    <div className="d-flex align-items-center">
      <Checkbox
        checked={isCheckBoxChecked} // ✅ use `checked`, not `value`
        onChange={(e) => setIsCheckBoxChecked(e.target.checked)} // ✅ proper change handling
      />
      <span className="pt-3">
        I understand & agree to the{" "}
        <span className="showmore">Terms and Conditions</span>.
      </span>
    </div>
  );

  return (
    <div className="grow">
      <div className="wrapper flex grow flex-col">
        <Header />
      </div>

      <main className="grow content" id="content" role="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-9 col-sm-12 ">
              <div className="card my-3">
                <div className="row g-0">
                  <div className="hotel-card-header border-bottom  p-4">
                    <div className="d-flex justify-content-between align-items-start">
                      <div>
                        <h4 className="h4 fw-bold">
                          {hotel?.HotelName || "Hotel Name"}
                          <span className="stars">
                            {"\u2605".repeat(parseInt(hotel?.HotelRating) || 1)}
                          </span>
                        </h4>
                        <div className="d-flex align-items-center">
                          <RoomIcon className="text-secondary" />
                          <p className="depar-info mb-0 ms-2 text-muted">
                            {hotel?.HotelAddress || "No address available"}
                          </p>
                        </div>
                      </div>
                      <div className="text-end">
                        <Badge
                          borderColor={
                            (
                              hotel?.CancellationPolicy ||
                              hotel?.BookingPolicy ||
                              ""
                            )
                              .toLowerCase()
                              .includes("non")
                              ? "#d9534f"
                              : "#2dca1c"
                          }
                          text={
                            (
                              hotel?.CancellationPolicy ||
                              hotel?.BookingPolicy ||
                              ""
                            )
                              .toLowerCase()
                              .includes("non")
                              ? "Non-refundable"
                              : "Refundable"
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <div className="row bg-light p-3 rounded mb-3">
                      <div className="col-md-4">
                        <h6>Check-In</h6>
                        <div className="fw-bold">
                          {hotel?.CheckInDate || "-"}
                        </div>
                        <small className="text-muted">
                          {hotel?.CheckInTime || "12:00 PM"}
                        </small>
                      </div>
                      <div className="col-md-4">
                        <h6>Check-Out</h6>
                        <div className="fw-bold">
                          {hotel?.CheckOutDate || "-"}
                        </div>
                        <small className="text-muted">
                          {hotel?.CheckOutTime || "11:00 AM"}
                        </small>
                      </div>
                      <div className="col-md-4">
                        <h6>Guest</h6>
                        <div className="fw-bold">
                          {hotel?.Guests?.Room?.[0]?.NumberOfAdults || 1} Adults
                        </div>
                        <small className="text-muted">
                          {hotel?.Guests?.Count || 1} Room | {nights} Night
                          {nights > 1 ? "s" : ""}
                        </small>
                      </div>
                    </div>

                    <div className="mt-2">
                      <div className="d-flex justify-content-between align-items-start mb-2">
                        <h3 className="h5 fw-semibold">
                          Room Type: {hotel?.RoomType || "Room Type"}
                        </h3>
                      </div>
                      <div className="row row-cols-2 row-cols-md-4 g-2">
                        {(hotel?.Meal || hotel?.MealType || "")
                          .split(",")
                          .map((item: string, idx: number) => (
                            <div className="col" key={idx}>
                              <div className="d-flex align-items-center gap-2">
                                <DoneAllIcon className="text-success" />
                                <span className="text-success">
                                  {item.trim()}
                                </span>
                              </div>
                            </div>
                          ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Guest Info */}
              <div className="card">
                <div className="">
                  <div className="card-header card-head-bg">
                    <p className="passenger-title">
                      <i className="fas fa-user passenger-icon pe-2" />
                      Guest Information
                    </p>
                  </div>

                  {/* Guest Names */}
                  <div className="card-body">
                    {guestData?.map((guest: any, index: number) => (
                      <div key={index} className="mb-2">
                        <span className="fw-bold">Adult {index + 1}:</span>{" "}
                        <span>
                          {guest?.title || "-"} {guest?.firstName || ""}{" "}
                          {guest?.lastName || ""}
                        </span>
                      </div>
                    ))}

                    {/* Divider */}
                    <hr className="my-3" />

                    {/* Shared Contact Details */}
                    <div className="row">
                      <div className="col-md-3">
                        <p className="info-label fw-bold mb-1">Email</p>
                        <p className="info-value">{contact?.email || "-"}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="info-label fw-bold mb-1">Passport</p>
                        <p className="info-value">{contact?.passport || "-"}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="info-label fw-bold mb-1">Mobile No.</p>
                        <p className="info-value">{contact?.mobile || "-"}</p>
                      </div>
                      <div className="col-md-3">
                        <p className="info-label fw-bold mb-1">Room</p>
                        <p className="info-value">
                          {payload?.Guests?.Count || 1}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* GST Details if any */}
                  {(gst?.gstNo ||
                    gst?.companyName ||
                    gst?.gstEmail ||
                    gst?.gstMobile ||
                    gst?.address) && (
                    <>
                      <hr className="my-3" />
                      <div className="px-4">
                        <p className="fs-6 fw-bold">GST Details</p>
                        <div className="row">
                          <div className="col-md-3">
                            <p className="info-label fw-bold mb-1">GST No.</p>
                            <p className="info-value">{gst?.gstNo || "-"}</p>
                          </div>
                          <div className="col-md-3">
                            <p className="info-label fw-bold mb-1">
                              Company Name
                            </p>
                            <p className="info-value">
                              {gst?.companyName || "-"}
                            </p>
                          </div>
                          <div className="col-md-3">
                            <p className="info-label fw-bold mb-1">GST Email</p>
                            <p className="info-value">{gst?.gstEmail || "-"}</p>
                          </div>
                          <div className="col-md-3">
                            <p className="info-label fw-bold mb-1">
                              GST Mobile Address
                            </p>
                            <p className="info-value">
                              {gst?.gstMobile || "-"}
                            </p>
                          </div>
                          <div className="col-md-12 mt-2">
                            <p className="info-label fw-bold mb-1">Address</p>
                            <p className="info-value">{gst?.address || "-"}</p>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Sidebar */}
            <div className="col-md-3">
              <div className="sticky-sidebar">
                <RoomPriceDetailCard
                  priceInfo={{
                    Price: hotel?.Price || 0,
                    disc: hotel?.disc || 0,
                    surchargeTotal: hotel?.surchargeTotal || 0,
                    TotalPrice: hotel?.TotalPrice || hotel?.total || 0,
                  }}
                  roomCount={hotel?.Guests?.Count || 1}
                  nights={nights}
                />
                <PaymentModeCard
                  activeStep={2}
                  createBooking={createBooking}
                  grandTotal={hotel?.TotalPrice || hotel?.total || 0}
                  bookingFor="hotel"
                  saveFlightBookingDetails={saveBookingDetail}
                  couponCode=""
                  flightSearchDetail={[]}
                  passengerDetail={[]}
                  termsAndCondition={<TermsAndCondition />}
                  isCheckBoxChecked={isCheckBoxChecked}
                />
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default HotelBookingDetail;
